import { phone, phoneLink, email, telegram } from "../data";

export default function Contact() {
  return (
    <section className="py-4 text-white" style={{ backgroundColor: '#1e1e2f' }}>
      <div className="container py-4 text-center">
        <h2 className="display-5 fw-bold mb-4">Свяжитесь с нами</h2>
        <p className="fs-4 mb-3">
          <a href={phoneLink} className="text-white text-decoration-none hover:text-danger">
            {phone}
          </a>
        </p>
        {/* <p className="fs-5 mb-4">
          <a href={`mailto:${email}`} className="text-white-50 text-decoration-none hover:text-white">
            {email}
          </a>
        </p>
        <div className="d-flex justify-content-center gap-3">
          <a href={telegram} target="_blank" rel="nofollow" className="btn btn-outline-light btn-lg rounded-pill px-5">
            Telegram
          </a>
        </div> */}
      </div>
    </section>
  );
}